import { Check } from "lucide-react";

import { cn } from "@/lib/utils";
import { INDEX_ICON } from "./indexIcon";

/**
 * The shared "completed" mark — a success circle with a card-coloured check.
 * Used by accordion, flip cards, checklist, … One definition; all sizes and
 * colours come from `INDEX_ICON`. Pass `className` for positioning (e.g. the
 * flip card pins it top-end).
 */
export function CompletionCheck({
    className,
    size = INDEX_ICON.checkSize,
    markSize = INDEX_ICON.checkMarkSize,
}: {
    className?: string;
    /** Circle size (defaults to the 24px completion check). */
    size?: string;
    /** The ✓ mark size (scale up when the circle is larger). */
    markSize?: string;
}) {
    return (
        <span
            className={cn(
                "flex shrink-0 items-center justify-center rounded-full",
                size,
                className
            )}
            style={{
                backgroundColor: INDEX_ICON.checkBg,
                color: INDEX_ICON.checkText,
            }}
        >
            <Check className={markSize} />
        </span>
    );
}
